'use client';

export default function GlobalError({ reset }: { error: Error; reset: () => void }) {
  return (
    <html>
      <body>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: '1rem' }}>
          <h1 style={{ fontSize: '1.5rem', color: '#dc2626' }}>Une erreur est survenue</h1>
          <button onClick={reset} style={{ padding: '0.5rem 1rem', cursor: 'pointer' }}>Réessayer</button>
        </div>
      </body>
    </html>
  );
}
